import { initMenu } from './_menu'
import { initHeader } from './_header'
import { initAnimation } from './_animation'
import { initSwipers } from './_swipers'
import { initVideoPlayer } from './_videoplayer'
import { initFilters } from './_filters'

import { Fancybox } from "@fancyapps/ui";




var initApp = function(){
   initMenu();
   initHeader();
   initAnimation();
   initSwipers();
   initVideoPlayer();
   initFilters();
};


initApp();